import { h } from 'preact';
const  quikr = (props) => (
	<svg viewBox="0 0 72 72" class={props.class}>
		<path d="M60.8,18.3c0.7,8.4-2.6,22.5-8.9,28.6c-1.4,1.4-3,2.5-4.7,3.4L44,44.8c-1.2-2.1-2.5-3.4-3.8-4.3c2-1.3,3.5-3.2,4.6-5.8c1.3-3.1,3.1-10.2,2.7-13.6c-0.5-3.7-3-6.7-8.8-7c-2.6-0.2-5.2,0-7.7,0.7c-2.2,0.6-4.1,1.6-5.4,2.9c-3.2,3-5.2,10.5-5.5,14.8c-0.2,3,0.2,5.3,1.3,6.8c1.9,2.8,4.9,3.1,7.9,3l2.3,0c3.6,0,6.6,0.4,9.7,5.6l3.9,6.8c2.2,3.6,2.6,4.7,7.9,4.7H65L62.6,71H49c-3.8,0-8.9-0.6-12-5.8l-4.6-7.9c-1.8-2.9-1.7-3.4-5-3.6c-3.6-0.2-7.6-0.6-9.8-1.5c-5.5-2.1-9.9-6.3-10.6-13.7c-0.2-1.9-0.1-3.9,0.1-6C7.4,30.2,8,27.3,8.6,25c1.5-6.2,3.7-11.3,7.6-15c5-4.8,12-6.7,18.6-6.9c2.6-0.1,7.1,0,10.9,0.5C53.9,4.7,60.1,9.5,60.8,18.3" />
	</svg>
);
export default quikr;


// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/quikr/index.js